module.exports = __webpack_public_path__ + "static/media/1.44704624.jpg";